import { render, staticRenderFns } from "./ranking-foto-modal.vue?vue&type=template&id=632f5bdb&scoped=true"
import script from "./ranking-foto-modal.vue?vue&type=script&lang=js"
export * from "./ranking-foto-modal.vue?vue&type=script&lang=js"
import style0 from "./ranking-foto-modal.vue?vue&type=style&index=0&id=632f5bdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632f5bdb",
  null
  
)

export default component.exports